const { date } = require('quasar');
const { cloneObj } = require('./helpers');

const emailMsgExtractor = (msgs) => {
  const emailBody = [];
  for (const msg of msgs) {
    const msgArr = msg.split(' ');
    const amPmIndex = msgArr.findIndex((x) => x === 'AM' || x === 'PM');
    const pond = amPmIndex > 0 ? msgArr.slice(0, amPmIndex - 2).join(' ') : '';
    const msgStr =
      amPmIndex > 0
        ? msgArr.slice(amPmIndex + 1, msgArr.length).join(' ')
        : msg;

    emailBody.push({ msg: msgStr, pond });
  }

  return emailBody;
};

const emailKeyBuilder = (email) => {
  return (
    email.farm_id +
    email.emailBody
      .map((x) => x.pond + x.msg)
      .join('')
      .split(' ')
      .join('')
      .split('.')
      .join('')
  );
};

const emailKeyBuilderUnique = (email) => {
  return (
    email.farm_id +
    email.date +
    email.emailBody
      .map((x) => x.pond + x.msg)
      .join('')
      .split(' ')
      .join('')
      .split('.')
      .join('')
  );
};

const CLUSTER_WINDOW_SECONDS = 48 * 60 * 60;

const oneEmailPerDay = (emails) => {
  const seen = new Set();
  const result = [];
  for (const email of emails) {
    const day = Math.floor(+date.startOfDate(email.date * 1000, 'day') / 1000);
    if (!seen.has(day)) {
      seen.add(day);
      result.push(email);
    }
  }
  return result;
};

const groupAlerts = (duplicates) => {
  const sorted = [...duplicates].sort((a, b) => b.date - a.date);

  const cluster = sorted.filter((e, i) =>
    sorted.some(
      (other, j) =>
        i !== j && Math.abs(e.date - other.date) <= CLUSTER_WINDOW_SECONDS
    )
  );

  const spans =
    sorted.length > 1 &&
    sorted[0].date - sorted[sorted.length - 1].date > CLUSTER_WINDOW_SECONDS;
  const spread = spans ? oneEmailPerDay(sorted) : [];

  return {
    representative: cloneObj(sorted[0]),
    cluster,
    spread
  };
};

const checkForWorkLog = (email, recentLogs) => {
  const emailMsgKey = email.emailBody
    .map((x) => `${x.pond} - ${x.msg}`)
    .join(' --- ')
    .split(' ')
    .join('');

  const filteredLogs = recentLogs
    .filter((x) => x.farm_id === email.farm_id)
    .filter((x) => x.office_notes.includes('[ Email: '));

  let numWorkLogs = 0;
  let workLogIds = [];
  for (const log of filteredLogs) {
    const officeNoteStr = log.office_notes
      .split('[ Email: ')
      .pop()
      .split('(')[0]
      .trim()
      .split(' ')
      .join('');

    if (officeNoteStr === emailMsgKey) {
      numWorkLogs += 1;

      workLogIds.push(log.id);
    }
  }

  return { numWorkLogs, workLogIds };
};

module.exports = {
  emailMsgExtractor,
  emailKeyBuilder,
  emailKeyBuilderUnique,
  groupAlerts,
  checkForWorkLog
};
